import { render, staticRenderFns } from "./default-partials.vue?vue&type=template&id=4679a807&"
import script from "./default-partials.vue?vue&type=script&lang=ts&"
export * from "./default-partials.vue?vue&type=script&lang=ts&"
import style0 from "./default-partials.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports